export default "__VITE_ASSET__CoFosi0E__"